// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { Button, Form, Modal } from 'react-bootstrap';
import type { MapStateToProps } from 'react-redux';
import Input from './Input';
import { convertValueToBoolean } from '../helpers';

type Props = {
  showTCModal: boolean,
  title: string,
  description: string,
  isSaving: boolean,
  errorMsg: ?string,
  successMsg: ?string,
  termsLinkUrl: ?string,
  handleSubmit: (v: any) => void
};

class UpdatedTCModal extends React.Component<Props> {
  render() {
    const {
      showTCModal = true,
      title,
      description,
      isSaving,
      handleSubmit,
      ...props
    } = this.props;

    return (
      <Modal show={showTCModal}>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{description}</p>
          <p>
            <a href={props.termsLinkUrl} target="_blank">
              Read Terms and Conditions
            </a>
          </p>
          <br />
          <Form onSubmit={handleSubmit}>
            <Field
              component={Input}
              type="toggle"
              label="I Accept the Terms and Conditions"
              name="acceptTerms"
              format={convertValueToBoolean}
            />
            <hr />
            <Button
              bsStyle="primary"
              type="submit"
              className="relative-padding"
              disabled={isSaving}
            >
              {isSaving ? 'Saving...' : 'Save'}
            </Button>
          </Form>
        </Modal.Body>
        {this.props.errorMsg && (
          <Modal.Footer>
            <div className="alert alert-danger" style={{ textAlign: 'left' }}>
              {this.props.errorMsg}
            </div>
          </Modal.Footer>
        )}
        {this.props.successMsg && (
          <Modal.Footer>
            <div className="text-success">{this.props.successMsg}</div>
          </Modal.Footer>
        )}
      </Modal>
    );
  }
}

UpdatedTCModal = reduxForm({
  form: 'updateTCModal'
})(UpdatedTCModal);

const mapStateToProps: MapStateToProps<*, *, *> = state => {
  return {
    formValues: getFormValues('updateTCModal')(state)
  };
};

export default connect(mapStateToProps)(UpdatedTCModal);



// WEBPACK FOOTER //
// ./src/components/UpdatedTCModal.js